export const parseTransactionTypeToString = (type: number): string => {
    switch (type) {
        case 0:
            return 'Uttag';
        case 1:
            return 'Tillförsel';
        case 2:
            return 'Kontroll';
        case 3:
            return 'Uttag från akutväska (till patient)';
        case 4:
            return 'Påfyllning av akutväska';
        case 5:
            return 'Kontroll av akutväskan vid skiftbyte';
        case 6:
            return 'Kassera';
        case 7:
            return 'Uttag från läkemedelsskåp';
        case 8:
            return 'Kassera';
        case 9:
            return 'Överföring till sal';
        case 10:
            return 'Retur från sal';
        case 11:
            return 'Förbrukat';
        default:
            return 'Okänd';
    }
};
